import http from '../../src/api/axiosConfig'

class AuthService {

    login(data) {
        console.log(data)
        return http.post('/auth/login-with-number', data)
    }

    register(data) {
        console.log(data)
        return http.post('/auth/registerTutor', data)
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AuthService()